export default __webpack_public_path__ + "0ced070eee0201ce6d26b764f5c9b10f.png";